module.exports = __webpack_public_path__ + "img/guide_download.2a4e4612.webp";